import type { BairroRegiao, CidadeView } from "../../../services/atribuirRegiao"

export type { BairroRegiao, CidadeView }

export type AtribuirRegiaoModel = {
    bairros: BairroRegiao[]
    cidadesEstabelecimento: CidadeView[]
    todasCidades: CidadeView[]
}

export const AtribuirRegiaoInicial: AtribuirRegiaoModel = {
    bairros: [],
    cidadesEstabelecimento: [],
    todasCidades: [],
}

export const novoBairroVazio = (tamanhoAtual: number): BairroRegiao => ({
    id: -(tamanhoAtual + 1),
    nomeBairro: "",
    idCidade: null,
    nomeCidade: null,
    taxaEntrega: "",
    taxaEntregaNoturna: null,
    minimoEntregaGratis: null,
    versao: null,
})
